<template>
  <div class="mb-1">
    <div v-if="incomingIntent && !isShow" style="margin-bottom: 5px">
      <div class="col s12" style="word-break: break-all">
        {{ incomingIntent.questiondata }}
        <template v-if="incomingIntent.count > 1">({{ incomingIntent.count }})</template>
      </div>
      <v-layout>
      <v-flex shrink>
        <v-checkbox
          style="margin-top: 0"
          color="primary"
          v-model="incomingIntent.selected"
        ></v-checkbox>
      </v-flex>
      <v-flex class="text-xs-right">
        <template v-if="!isShow">
          <v-btn
            class="btn-trainingitem"
            outline
            color="grey"
            href="javascript:void(0);"
            :loading="loading"
            :disabled="loading"
            style="margin-bottom: 2px; margin-top: 2px"
            @click="$store.getters.getPackage == 'premium' ? $emit('onIgnore') : false"
            >{{ $t('Delete') }}</v-btn
          >
          <v-btn
            class="btn-trainingitem"
            depressed
            color="primary"
            :loading="loading"
            :disabled="loading"
            href="javascript:void(0);"
            style="margin-bottom: 2px; margin-top: 2px"
            @click="$store.getters.getPackage == 'premium' ? (isShow = true) : false"
            >{{ $t('Create new') }}</v-btn
          >
          <v-btn
            class="btn-trainingitem"
            depressed
            color="primary"
            :loading="loading"
            :disabled="loading"
            href="javascript:void(0);"
            style="margin-bottom: 2px; margin-top: 2px"
            @click="
              $store.getters.getPackage == 'premium' ? $emit('onAddExistingConversation') : false
            "
            >{{ $t('Add existing') }}</v-btn
          >
        </template>
      </v-flex>
      </v-layout>
    </div>
    <div v-if="isShow">
      <div>
        <manage-intent
          :type="'add'"
          v-model="newIntent"
          @close="onClose"
          @saveIntent="onSaveIntent"
          :excludedIntentName="excludedIntentName"
        ></manage-intent>
      </div>
    </div>
  </div>
</template>

<script>
import ManageIntent from './intent-manage'
export default {
  props: ['value', 'excludedIntentName', 'loadingId'],
  data: function() {
    return {
      isShow: false,
      newIntent: {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: '',
        a_val: [[]],
        context_in: '',
        context_out: '',
        quick_reply: ''
      },
      incomingIntent: undefined
    }
  },
  components: {
    ManageIntent
  },
  mounted: function() {
    this.incomingIntent = this.value
    this.newIntent.q_val = this.value.questiondata
  },
  computed: {
    loading() {
      let vm = this
      return vm.incomingIntent.questiondata == vm.loadingId
    }
  },
  methods: {
    onClose: function() {
      var vm = this
      vm.isShow = false
    },
    onSaveIntent: function() {
      var vm = this
      var data = {
        intentname: vm.newIntent.intentname,
        questiondata: vm.incomingIntent.questiondata
      }
      this.$emit('onSaveTrainingConversation', data)
      this.onClose()
    }
  },
  watch: {
    value: function() {
      this.incomingIntent = this.value
      this.newIntent.q_val = this.value.questiondata
    }
  }
}
</script>

<style scoped>
.btn-trainingitem {
  margin: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/TrainingItem.vue